import React from 'react';
import './styles.scss';

const PackageCardLoading = () => (
  <div className="packageCardWrapper">
    <div className="imageCardWrapperLoading" />
    <div className="packageTextContainer">
      <div className="packageTopSection">
        <p className="packageHeadLoading" />
        <div className="itineraryListLoading">
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
        <ul className="tripListWrapperLoading">
          <li>
            <span />
          </li>
          <li>
            <span />
          </li>
          <li>
            <span />
          </li>
          <li>
            <span />
          </li>
          <li>
            <span />
          </li>
        </ul>
        <ul className="visitListWrapperLoading">
          <li />
          <li />
        </ul>
      </div>
      <div className="packageBottomSection">
        <div className="includeWrapper">
          <div className="includeItemCardLoading">
            <span className="leftSecLoading">
              <span />
              <span />
            </span>
            <span className="rightSecLoading">
              <span />
              <span />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default PackageCardLoading;
